import * as React from "react";
import { CountryCodeEnum } from "../types";

interface GlobalNavProps {
  countryCode: CountryCodeEnum;
}

export const GlobalNav: React.FC<GlobalNavProps> = ({ countryCode }) => {
  return (
    <nav className="global-nav-wrapper">
      <div className="container">
        <ul className="global-nav">
          <li className="global-nav__list-item global-nav__network">
            <ul className="global-nav">
              <li className="global-nav__list-item">
                <a
                  className="global-nav__link"
                  href={
                    countryCode === CountryCodeEnum.AU
                      ? "https://www.seek.com.au"
                      : "https://www.seek.co.nz"
                  }
                >
                  Jobs
                </a>
              </li>
              <li className="global-nav__list-item">
                <a
                  className="global-nav__link global-nav__link-courses"
                  href={
                    countryCode === CountryCodeEnum.AU
                      ? "https://www.seeklearning.com.au"
                      : "https://www.seeklearning.co.nz"
                  }
                >
                  Courses
                </a>
              </li>
              <li className="global-nav__list-item">
                <a
                  className="global-nav__link global-nav__link-businesses"
                  // NO NZ SITE CURRENTLY AFAIK FOR SEEK BUSINESSES
                  href="https://www.seekbusiness.com.au"
                >
                  Businesses
                  <span className="d-none d-md-inline">&nbsp;for sale</span>
                </a>
              </li>
              <li className="global-nav__list-item active">
                <span className="global-nav__static">
                  Volunteer<span className="d-none d-sm-inline">ing</span>
                  <span className="sr-only">, current page</span>
                </span>
              </li>
            </ul>
          </li>
          <li className="global-nav__list-item global-nav__locale">
            <ul className="global-nav">
              {countryCode === CountryCodeEnum.AU ? (
                <>
                  <GlobalNavLocale active href="https://www.volunteer.com.au">
                    AU
                  </GlobalNavLocale>
                  <GlobalNavLocale href="https://www.seekvolunteer.co.nz/">
                    NZ
                  </GlobalNavLocale>
                </>
              ) : (
                <>
                  <GlobalNavLocale
                    active
                    href="https://www.seekvolunteer.co.nz/"
                  >
                    NZ
                  </GlobalNavLocale>
                  <GlobalNavLocale href="https://www.volunteer.com.au">
                    AU
                  </GlobalNavLocale>
                </>
              )}
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  );
};

interface GlobalNavLocaleProps {
  active?: boolean;
  href: string;
}

const GlobalNavLocale: React.FC<GlobalNavLocaleProps> = ({
  active,
  href,
  children,
}) => {
  if (active) {
    return (
      <li className="global-nav__list-item d-none d-sm-flex active">
        <span className="global-nav__static">
          {children} <span className="sr-only">, current page</span>
        </span>
      </li>
    );
  }

  return (
    <li className="global-nav__list-item">
      <a className="global-nav__link" href={href}>
        {children}
      </a>
    </li>
  );
};
